import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY } from "../constants";
export var es = /*#__PURE__*/_defineProperty({}, CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY, {
  MODULE_HOME: 'Inicio',
  MODULE_RECOGNITION: 'Reconocimiento',
  MODULE_PERFORMANCE: 'Desempeño',
  MODULE_CLIMATE: 'Clima',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Compañía',
  MODULE_ANALYTICS: 'Analítica',
  MODULE_MY_RESULTS: 'Mis Resultados',
  TOOLTIP_CLIMATE_DESCRIPTION: 'Mide la cultura y satisfacción de tu equipo.',
  TOOLTIP_PERFORMANCE_DESCRIPTION: 'Evalúa el rendimiento, a través de objetivos y competencias.',
  TOOLTIP_LEARNING_DESCRIPTION: 'Gestiona estrategias de aprendizaje y potencia las habilidades de tus equipos.',
  TOOLTIP_RECOGNITION_DESCRIPTION: 'Gestiona las medallas otorgadas por los colaboradores.',
  TOOLTIP_COMPANY_DESCRIPTION: 'Monitorea tus procesos y genera reportes.',
  TOOLTIP_ANALYTICS_DESCRIPTION: 'Consulta los resultados de los procesos en los que participas.',
  TOOLTIP_MY_RESULTS_TITLE: 'Resultados',
  TOOLTIP_MY_RESULTS_DESCRIPTION: 'Analiza tus resultados y los del equipo que lideras.',
  SUBMODULE_RESULTS_TITLE: 'Mis resultados',
  SUBMODULE_TOOLTIP_MY_RESULTS_DESCRIPTION: 'Consulta los resultados de los procesos en los que participas',
  SUBMODULE_LEADER_RESULTS_TITLE: 'Mi equipo',
  SUBMODULE_TOOLTIP_LEADER_RESULTS_DESCRIPTION: 'Monitorea los resultados de tu equipo',
  SUBMODULE_DIRECTORY_TITLE: 'Directorio',
  SUBMODULE_TOOLTIP_DIRECTORY_DESCRIPTION: 'Información de los miembros de la compañía',
  SUBMODULE_COMPANY_CHART_TITLE: 'Organigrama',
  SUBMODULE_COMPANY_CHART_DESCRIPTION: 'Conoce la estructura de la compañía',
  SUBMODULE_RECOGNITION_TITLE: 'Medallas',
  SUBMODULE_TOOLTIP_RECOGNITION_DESCRIPTION: 'Envía medallas a tus compañero y mira las que recibiste',
  SUBMODULE_RECOGNITION_REDEMPTION_TITLE: 'Recompensas',
  SUBMODULE_TOOLTIP_RECOGNITION_REDEMPTION_DESCRIPTION: 'Canjea los puntos que obtuviste por tus logros',
  SUBMODULE_OKRS_PERFORMNACE_TITLE: 'OKRs',
  SUBMODULE_TOOLTIP_OKRS_PERFORMANCE_DESCRIPTION: 'Visualiza el progreso de la estrategia empresarial y reconoce el esfuerzo para cumplir los objetivos',
  SUBMODULE_GOALS_TITLE: 'Metas',
  SUBMODULE_TOOLTIP_GOALS_DESCRIPTION: 'Planea y establece tus compromisos de trabajo',
  SUBMODULE_COMPETENCES_TITLE: 'Evaluaciones',
  SUBMODULE_TOOTLTIP_COMPETENCES_DESCRIPTION: 'Accede a los cuestionarios de los procesos asignados',
  SUBMODULE_FEEDBACK_TITLE: 'Feedback',
  SUBMODULE_TOOLTIP_FEEDBACK_DESCRIPTION: 'Mide los procesos de feedback de tu compañía.',
  SUBMODULE_PID_TITLE: 'Plan individual de desarrollo',
  SUBMODULE_TOOLTIP_PID_DESCRIPTION: 'Crea procesos para cerrar brechas y promover el crecimiento.',
  SUBMODULE_SUCESSION_PLAN_TITLE: 'Plan de sucesión',
  SUBMODULE_TOOLTIP_SUCESSION_PLAN_DESCRIPTION: 'Crea planes de acción para futuras vacantes.',
  SUBMODULE_CLIMATE_EVALUATION_TITLE: 'Evaluaciones de Clima',
  SUBMODULE_TOOLTIP_CLIMATE_EVALUATION_DESCRIPTION: 'Accede al cuestionario para mediar el clima organizacional',
  SUBMODULE_SURVEY_TITLE: 'Encuestas',
  SUBMODULE_TOOLTIP_SURVEY_DESCRIPTION: 'Ayuda a tu empresa a recolectar información de manera rápida y sencilla',
  // Learning links
  LEARNING_LINK_LEARND_AND_PROGRESS: 'APRENDIZAJE Y PROGRESO',
  LEARNING_LINK_ENROLLED_COURSES: 'Cursos',
  LEARNING_LINK_TOOLTIP_MORE_FOR_YOU_DESCRIPTION: 'Descubre los nuevos contenidos de aprendizaje',
  LEARNING_LINK_PATHS: 'Rutas de aprendizaje',
  LEARNING_LINK_LIVE_SESSIONS: 'Sesiones en vivo',
  LEARNING_LINK_NOTES: 'Apuntes',
  LEARNING_LINK_STUDY_PLAN: 'Plan de estudios',
  LEARNING_LINK_TOOLTIP_STUDY_PLAN: 'Planifica tu meta de aprendizaje',
  LEARNING_LINK_BLOG: 'Blog',
  LEARNING_LINK_LIVES: 'Lives',
  LEARNING_LINK_TOOLS: 'Herramientas',
  LEARNING_LINK_EVALUATIONS_AND_GOALS: 'EVALUACIÓN Y LOGROS',
  LEARNING_LINK_SKILL_XP: 'Skill XP',
  LEARNING_LINK_PROJECTS: 'Proyectos',
  LEARNING_LINK_TOOLTIP_PROJECTS_DESCRIPTION: 'Lleva a cabo los proyectos de tus cursos',
  LEARNING_LINK_DIPLOMA: 'Diplomas',
  LEARNING_LINK_TOOLTIP_DIPLOMA_DESCRIPTION: 'Consulta los diplomas obtenidos por el cumplimiento de tu aprendizaje',
  LEARNING_LINK_PENDING_TESTS: 'Tests pendientes',
  LEARNING_LINK_DONE_TESTS: 'Tests resueltos',
  LEARNING_LINK_ACCHIEVEMENTS: 'Logros',
  LEARNING_LINK_REWARDS: 'Recompensas',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
  LEARNING_LINK_TOOLTIP_SKILL_XP_EVOLUTION_DESCRIPTION: 'Toma los test e identifica el nivel de tus habilidades',
  LEARNING_LINK_GAMIFICATION: 'Gamificación',
  LEARNING_LINK_TOOLTIP_GAMIFICATION_DESCRIPTION: 'Gana recompensas por tus logros de aprendizaje',
  LEARNING_LINK_MY_COURSES: 'Mis cursos',
  LEARNING_LINK_TOOLTIP_MY_COURSES_DESCRIPTION: 'Accede a cursos y rutas en los que estás inscrito',
  LEARNING_LINK_RESOURCES: 'Recursos',
  LEARNING_LINK_TOOLTIP_RESOURCES_DESCRIPTION: 'Recursos de aprendizaje',
  LEARNING_LINK_COURSES: 'Cursos',
  LEARNING_LINK_DISCOVER: 'Descubre',
  LEARNING_LINK_KNOWLEDGE_HUB: 'Catálogo',
  // Misc
  SIDEBAR_BACK: 'Volver',
  SIDEBAR_BACK_TO_PRODUCTS: 'Volver a mis productos',
  SIDEBAR_EXPAND: 'Expandir menu',
  SIDEBAR_COLLAPSE: 'Colapsar menu',
  SIDEBAR_HELP: 'Ayuda',
  SIDEBAR_HELP_DESCRIPTION: 'Accede a los recursos y canal de soporte.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUCTOS',
  // Admin data
  MODULE_HANA: 'Crehana AI',
  MODULE_ADMIN: 'Administrar',
  MODULE_STATISTICS: 'Estadísticas',
  MODULE_REPORTS: 'Reportes',
  MODULE_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitorea tus procesos y genera reportes.',
  MODULE_HANA_TOOLTIP_DESCRIPTION: 'Analiza la data de tu compañía con Inteligencia Artificial.',
  MODULE_RECOGNITION_TOOLTIP_DESCRIPTION: 'Gestiona las medallas otorgadas por los colaboradores.',
  MODULE_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Evalúa el rendimiento, a través de objetivos y competencias.',
  MODULE_CLIMATE_TOOLTIP_DESCRIPTION: 'Mide la cultura y satisfacción de tu equipo.',
  MODULE_LEARNING_TOOLTIP_DESCRIPTION: 'Gestiona estrategias de aprendizaje y potencia las habilidades de tus equipos.',
  MODULE_COMPANY_USERS: 'Usuarios',
  MODULE_COMPANY_EXTRA_FIELDS: 'Atributos personalizados',
  MODULE_COMPANY_DEPARTMENTS: 'Departamentos',
  MODULE_COMPANY_JOBS: 'Cargos',
  MODULE_COMPANY_ORGCHART: 'Organigrama',
  MODULE_ADMIN_TOOLTIP_DESCRIPTION: 'Gestiona tus usuarios y la configuración de la compañía.',
  MODULE_COMPANY_TOOLTIP_DESCRIPTION: 'Crea usuarios y gestiona la estructura organizacional',
  MODULE_ACCOUNT: 'Cuenta',
  MODULE_ACCOUNT_TOOLTIP_DESCRIPTION: 'Gestiona los datos de la cuenta y consulta el consumo de licencias',
  MODULE_LOGS: 'Logs',
  MODULE_LOGS_TOOLTIP_DESCRIPTION: 'Historial de acciones realizadas en la cuenta.',
  MODULE_APPEREANCE: 'Apariencia',
  MODULE_APPEREANCE_TOOLTIP_DESCRIPTION: 'Personaliza el panel con la identidad organizacional',
  MODULE_COMMUNICATION: 'Comunicación',
  MODULE_COMMUNICATION_TOOLTIP_DESCRIPTION: 'Personaliza las notificaciones para tus usuarios',
  MODULE_AUTOMATIZATIONS: 'Automatizaciones',
  MODULE_AUTOMATIZATIONS_TOOLTIP_DESCRIPTION: 'Crea reglas de automatización para agilizar tareas',
  // learning links
  LEARNING_LINK_CONTENT: 'Contenido',
  LEARNING_LINK_CONTENT_TOOLTIP_DESCRIPTION: 'Gestiona los cursos, rutas de aprendizaje y otros recursos',
  LEARNING_LINK_SKILL_XP_EVOLUTION_TOOLTIP_DESCRIPTION: 'Mide las habilidades de cada persona',
  LEARNING_LINK_GAMIFICATION_TOOLTIP_DESCRIPTION: 'Crear, gestionar y premia logros de aprendizaje',
  LEARNING_LINK_PROGRESS: 'Progreso',
  LEARNING_LINK_ANALYTICS_TOOLTIP_DESCRIPTION: 'Monitorea tus procesos y genera reportes',
  LEARNING_LINK_SHOP: 'Tienda',
  LEARNING_LINK_SHOP_TOOLTIP_DESCRIPTION: 'Personaliza tu tienda virtual de contenido',
  LEARNING_LINK_INTEGRATIONS: 'Integraciones',
  LEARNING_LINK_INTEGRATIONS_TOOLTIP_DESCRIPTION: 'Conecta la plataforma con otros sistemas',
  // submodules
  SUBMODULE_RESULTS: 'Resultados',
  SUBMODULE_RESULTS_TOOLTIP_DESCRIPTION: 'Consulta los resultados de los procesos en los que participas',
  SUBMODULE_MY_TEAM: 'Mi equipo',
  SUBMODULE_MY_TEAM_TOOLTIP_DESCRIPTION: 'Monitorea los resultados de tu equipo',
  SUBMODULE_ADMIN_RESULTS: 'Resultados',
  SUBMODULE_ADMIN_RESULTS_TOOLTIP_DESCRIPTION: 'Monitorea el ranking de medallas obtenidas por tus colaboradores.',
  SUBMODULE_MEDALS_REQUETS: 'Solicitud de medallas',
  SUBMODULE_MEDALS_REQUETS_TOOLTIP_DESCRIPTION: 'Aprueba o rechaza las medallas que se envían los colaboradores.',
  SUBMODULE_REWARDS: 'Recompensas',
  SUBMODULE_REWARDS_TOOLTIP_DESCRIPTION: 'Gestiona y entrega las recompensas canjeadas.',
  SUBMODULE_CONFIGURATION: 'Configuración',
  SUBMODULE_CONFIGURATION_TOOLTIP_DESCRIPTION: 'Crea medallas, define reglas y mensajes.',
  SUBMODULE_RESULTS_PERFORMANCE: 'Resultados',
  SUBMODULE_RESULTS_PERFORMANCE_TOOLTIP_DESCRIPTION: 'Mide el desempeño y el compromiso de los equipos.',
  SUBMODULE_COMPETENCES: 'Competencias',
  SUBMODULE_COMPETENCES_TOOLTIP_DESCRIPTION: 'Crea y asigna evaluaciones de competencias.',
  SUBMODULE_GOALS: 'Metas',
  SUBMODULE_GOALS_TOOLTIP_DESCRIPTION: 'Planea y establece tus compromisos de trabajo',
  SUBMODULE_OKRS: 'OKRs',
  SUBMODULE_OKRS_TOOLTIP_DESCRIPTION: 'Visualiza el progreso de la estrategia empresarial y reconoce el esfuerzo para cumplir los objetivos',
  SUBMODULE_FEEDBACK: 'Feedback',
  SUBMODULE_FEEDBACK_TOOLTIP_DESCRIPTION: 'Mide los procesos de feedback de tu compañía.',
  SUBMODULE_PID: 'Plan individual de desarrollo',
  SUBMODULE_PID_TOOLTIP_DESCRIPTION: 'Crea procesos para cerrar brechas y promover el crecimiento.',
  SUBMODULE_SUCCESSION_PLAN: 'Plan de sucesión',
  SUBMODULE_SUCCESSION_PLAN_TOOLTIP_DESCRIPTION: 'Crea planes de acción para futuras vacantes.',
  SUBMODULE_LINK_GOALS: 'Objetivos',
  SUBMODULE_LINK_ALIGNMENT: 'Alineación',
  SUBMODULE_LINK_CONFIGURATION: 'Configuracion',
  SUBMODULE_CLIMATE_EVALUATION: 'Evaluaciones de Clima',
  SUBMODULE_CLIMATE_EVALUATION_TOOLTIP_DESCRIPTION: 'Accede al cuestionario para mediar el clima organizacional',
  SUBMODULE_SHORT_SURVEY: 'Encuestas cortas',
  SUBMODULE_SHORT_SURVEY_TOOLTIP_DESCRIPTION: 'Recolecta información de manera rápida y sencilla.',
  SUBMODULE_OTHER_EVALUATIONS: 'Otras evaluaciones',
  SUBMODULE_OTHER_EVALUATIONS_TOOLTIP_DESCRIPTION: 'Evaluaciones adicionales como riesgos psicosociales.',
  SUBMODULE_CONFIGURATION_MEDALS: 'Medallas',
  SUBMODULE_CONFIGURATION_MESSAGES: 'Mensajes',
  SUBMODULE_CONFIGURATION_RULES_AND_PERMISSIONS: 'Reglas y permisos',
  SUBMODULE_TALENT: 'Talent',
  SUBMODULE_LEARNING: 'E-Learning',
  SUBMODULE_NBOX: 'N-Box',
  SUBMODULE_NBOX_TOOLTIP_DESCRIPTION: 'Crea matrices cruzando variables para visualizar datos.'
});